import React, { useState, useEffect } from "react";
import "./NewProducts.css";
import ProductCard from "../../components/ProductCard/ProductCard";
import Loaderdots from "../../components/LoaderDots/Loaderdots";
import { Link } from "react-router-dom";

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // Loader state

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        // Fetch all products at once with a large limit
 const response = await fetch("https://riymay.com/api/v1/user/products?limit=100");
        const data = await response.json();

        // Filter only public products and set to state
        setProducts(data.products.filter((product) => product.visibility === "public"));
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) return <div><Loaderdots /></div>; // Show loader while fetching

  return (
    <div className="product-grid">
      {products.length > 0 ? (
        products.map((product, index) => (
          <Link className="product-card-container" key={product._id} to={`/product/${product._id}`}>
          <ProductCard key={`${product._id}${index}`} product={product} /></Link>
        ))
      ) : (
        <div>No products available.</div> // Fallback if no products are found
      )}
    </div>
  );
};

export default ProductGrid;